import { trace, context, SpanStatusCode, SpanKind, TraceFlags } from '@opentelemetry/api';
import { setSemanticAttributes, getParentSpan } from './trace';
const tracer = trace.getTracer('rtk-tracer');
const unknownType = 'rtk-action-without-type';
const noSpanners = [
    'internal_getRTKQSubscriptions',
    'internalSubscriptions',
    'middlewareRegistered',
    'persist/PERSIST',
    'persist/REHYDRATE',
    'removeQueryResult',
    'removeMutationResult',
    'tasks/updateTask',
    unknownType,
    'unsubscribeQueryResult',
];
const spanMiddleware = (_store) => (next) => (action) => {
    var _a;
    const spanName = `${(_a = action === null || action === void 0 ? void 0 : action.type) !== null && _a !== void 0 ? _a : unknownType}`;
    for (const skip of noSpanners) {
        if (spanName.includes(skip)) {
            return next(action);
        }
    }
    const parentSpan = getParentSpan();
    const spanContext = parentSpan === null || parentSpan === void 0 ? void 0 : parentSpan.spanContext();
    const traceFlags = TraceFlags.SAMPLED;
    const links = spanContext ? [{ context: Object.assign(Object.assign({}, spanContext), { traceFlags }) }] : undefined;
    const spanOptions = {
        kind: SpanKind.SERVER,
        attributes: {
            'http.scheme': 'render',
            'http.pathname': spanName,
        },
        links,
    };
    const currentSpan = tracer.startSpan(spanName, spanOptions);
    setSemanticAttributes(currentSpan);
    const { setSpan } = trace;
    return context.with(setSpan(context.active(), currentSpan), () => {
        var _a, _b, _c;
        const actionMeta = action === null || action === void 0 ? void 0 : action.meta;
        if (actionMeta && typeof actionMeta === 'object') {
            const endpointName = (_a = actionMeta === null || actionMeta === void 0 ? void 0 : actionMeta.arg) === null || _a === void 0 ? void 0 : _a.endpointName;
            if (endpointName) {
                currentSpan.updateName(`${endpointName}-${spanName}`);
            }
            const originalArgs = (_b = actionMeta === null || actionMeta === void 0 ? void 0 : actionMeta.arg) === null || _b === void 0 ? void 0 : _b.originalArgs;
            if (typeof originalArgs === 'object') {
                const type = (_c = originalArgs === null || originalArgs === void 0 ? void 0 : originalArgs.type) !== null && _c !== void 0 ? _c : 'query';
                const attributes = {};
                for (const [key, value] of Object.entries(originalArgs)) {
                    if (typeof value !== 'undefined') {
                        const semanticKey = `${endpointName}.${type}.${key}`;
                        Object.assign(attributes, { [semanticKey]: value });
                    }
                }
                currentSpan.setAttributes(attributes);
            }
        }
        try {
            const result = next(action);
            currentSpan.setStatus({ code: SpanStatusCode.OK });
            return result;
        }
        catch (error) {
            currentSpan.setStatus({ code: SpanStatusCode.ERROR });
            currentSpan.recordException(error);
            throw error;
        }
        finally {
            currentSpan.end();
        }
    });
};
export default spanMiddleware;
//# sourceMappingURL=reduxMiddleware.js.map